// extracted by mini-css-extract-plugin
export var icon = "_5g-1";
export var subtext = "_5g-0";